import React, { Component } from 'react';
import './tenantSelect.styl';
import store from 'store';
import { hrefHomeByToken } from '@/utils/util';
import { message } from 'antd';
import { userTenantList, userSwitchTenant, checkIntranet } from '@/api/tenant';
import defaultIcon from '@/assets/images/placeholder.png';

export default class Compon extends Component {
  tenantSelectRef = React.createRef();

  state = {
    tenantList: [],
  };

  componentDidMount() {
    document.title = '选择工作台';
    this.tenantSelectRef.current.setTenantLoading = false;
    this.handleTenant();
  }

  async handleTenant() {
    try {
      const bizOrgList = await userTenantList();
      this.setState({ tenantList: bizOrgList })
    } catch (error) {
      if (error && error.code && [401, 40101].includes(error.code)) {
        return
      }
      message.warning(error.message || '查询失败');
    }
  };

  // 设置首页
  async setTenant(item) {
    try {
      if (this.tenantSelectRef.current.setTenantLoading) return;
      this.tenantSelectRef.current.setTenantLoading = true;
      // 判断租户类型，是否需要内外网判断
      if (item.bizOrgType === 1) {
        const isInternet = await checkIntranet();
        if (!isInternet) {
          message.warning('请使用锐锢内网或锐锢VPN访问');
          return;
        }
      }
      store.set('openModule', null);
      store.set('openModuleOpenInfo', null);
      await userSwitchTenant({
        bizOrgId: item.id,
        clientId: process.env.REACT_APP_CLIENT_ID
      });
      const token = store.get('token');
      hrefHomeByToken(token, [], {}, this.props.history, () => {
        this.tenantSelectRef.current.setTenantLoading = false;
      });
    } catch (error) {
      message.warning(error.message || '选择失败');
      this.tenantSelectRef.current.setTenantLoading = false;
    }
  }

  render() {
    const { tenantList } = this.state;
    return (
      <div className="tenantSelect" ref={this.tenantSelectRef}>
        <div className="flex-col-start-center tenantSelect-cot">
          <div className="flex-row-center-center fs-22 bold m-t-20 m-b-20">选择工作台进入</div>
          <div className="flex-row-center-center tenantSelect-list">
            {tenantList.map((item, index) => (
              <div key={`tenantList-${index}`} onClick={() => this.setTenant(item)} className="flex-col-between-center tenantSelect-item">
                <span></span>
                <div className="flex-col-between-center">
                  <img
                    src={item.logo || defaultIcon}
                    className="tenantSelect-item-logo"
                    alt=""
                  />
                  <div className="fs-22 bold m-t-20 m-b-20">{item.bizOrgText}</div>
                </div>
                <div className="flex-row-center-center select-btn">立即进入</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
